const keys = {
  poolSubquestion: {
    title: 'When was the pool installed?',
    placeholder: 'Installation Year',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
